<div class="column padding gap-xs background-grey-300 grey-color-700">
  <span class="text-md semi-bold">{{
    (isModifying ? 'announcements.modifyModal.title' : 'announcements.createModal.title') | translate
  }}</span>

  <span class="text-sm">{{
    (isModifying  && currentActiveAnnouncement?.isActive ? 'announcements.modifyModal.subtitle' : 'announcements.createModal.subtitle') | translate
  }}</span>
</div>

<form class="column padding-sm gap" [formGroup]="announcementForm">
  <div class="row gap">
    <div id="announcement-verticals" class="column gap-md">
      <span class="text-md">{{ 'global.verticals' | translate }}</span>

      <mat-form-field>
        <mat-select formControlName="verticals" multiple>
          <mat-option *ngFor="let vertical of verticals" [value]="vertical.domain">
            <span class="text-md normal-weight">{{ vertical.name }}</span>
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div id="announcement-type" class="column gap-md">
      <span class="text-md">{{ 'announcements.createModal.type' | translate }}</span>

      <mat-form-field>
        <mat-select formControlName="type">
          <mat-option *ngFor="let type of announcementTypes" [value]="type">
            <span class="text-md normal-weight">{{ 'announcements.typeOptions.'+type | translate }}</span>
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>

  <div class="column gap">
    <span class="text-lg semi-bold black-color">{{ 'announcements.createModal.bodyTitle' | translate }}</span>

    <div formGroupName="body" class="column gap">
      <div class="column gap-md" *ngFor="let lang of AnnouncementBody.getPropertyNames()">
        <span class="text-md">{{ 'announcements.createModal.bodyLanguages.' + lang | translate }}</span>
        <mat-form-field class="w-full text-md normal-weight">
          <textarea matInput formControlName="{{lang}}" placeholder="{{ 'announcements.createModal.bodyPlaceholder.' + lang | translate }}" name="body-{{lang}}" id="body-{{lang}}" lang="{{lang}}" rows="3"></textarea>
        </mat-form-field>
      </div>
    </div>
  </div>

  <div class="column gap">
    <span class="text-lg semi-bold black-color">{{ 'announcements.createModal.dateTitle' | translate }}</span>
    <div class="row gap-md">
      <div class="column gap date-field">
        <mat-checkbox
          color="primary"
          [checked]="announcementForm.value.startDateCheckBox"
          formControlName="startDateCheckBox"
          (click)="addRemoveStartDate()"
        >
          {{ 'announcements.createModal.startDate' | translate }}
        </mat-checkbox>
        <div *ngIf="announcementForm.value.startDateCheckBox && announcementForm.value.startDate" class="column gap-md">
          <span class="text-md">{{ 'announcements.createModal.startDateLabel' | translate }}</span>

          <mat-form-field (click)="startDate.open()">
            <input
              readonly
              formControlName="startDate"
              class="announcement--date-picker"
              matInput
              [ngxMatDatetimePicker]="startDate"
            />
            <ngx-mat-datepicker-toggle matIconSuffix [for]="startDate"></ngx-mat-datepicker-toggle>
            <ngx-mat-datetime-picker #startDate [showSpinners]="false"></ngx-mat-datetime-picker>
          </mat-form-field>
        </div>
      </div>
      <div class="column gap date-field">
        <mat-checkbox
          color="primary"
          [checked]="announcementForm.value.endDateCheckBox"
          formControlName="endDateCheckBox"
          (click)="addRemoveEndDate()"
          >{{ 'announcements.createModal.endDate' | translate }}</mat-checkbox
        >

        <div
          *ngIf="announcementForm.value.endDateCheckBox && announcementForm.value.endDate !== undefined"
          class="column gap-md"
        >
          <span class="text-md">{{ 'announcements.createModal.endDateLabel' | translate }}</span>

          <mat-form-field (click)="endDate.open()">
            <input
              readonly
              formControlName="endDate"
              class="announcement--date-picker"
              matInput
              placeholder="XX/XX/XXXX XX:XX"
              [ngxMatDatetimePicker]="endDate"
            />
            <ngx-mat-datepicker-toggle matIconSuffix [for]="endDate"></ngx-mat-datepicker-toggle>
            <ngx-mat-datetime-picker #endDate [showSpinners]="false"></ngx-mat-datetime-picker>
          </mat-form-field>
        </div>
      </div>
    </div>
  </div>

  <div class="row horizontal-end gap-md">
    <button mat-button class="btn btn--secondary no-ripple" (click)="closeModal()">
      {{ 'global.close' | translate }}
    </button>

    <button
      appLoadingButton
      mat-button
      class="btn btn--primary"
      (click)="createModifyAnnouncement()"
      [disabled]="announcementForm.invalid"
    >
      {{ (isModifying ? 'global.saveChanges' : 'announcements.btnActions.create') | translate }}
    </button>
  </div>
</form>
